import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);

export default class Chiffre extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      chiffre: {}
    };
  }

  mount() {
    let that = this;
    let snap = 10;
    if (this.ref.chiffre.innerText.length == 2) {
      snap = 1;
    }
    gsap.from(this.ref.chiffre, {
      innerText: 0,
      duration: 5,
      scrollTrigger:{
        trigger: this.ref.chiffre,
        start: 'bottom bottom',
      },
      snap: {
        innerText: snap
      }
    });

  }
}